<div class="flex-wrapper CssTitleWrapper">
  <i class="CssTitleIcon fad fa-bug"></i>
  <div class="ui-dialog-titlebar ui-helper-clearfix ui-corner-top">
    <span class="ui-dialog-title">{{ config.header }}</span>
    <div class="ui-dialog-titlebar-icons">
      <a
        [ngClass]="'ui-dialog-titlebar-icon ui-dialog-titlebar-close ui-corner-all'"
        tabindex="0"
        role="button"
        (click)="this.ref.close()"
        (keydown.enter)="this.ref.close()"
      >
        <span class="fa fa-times"></span>
      </a>
    </div>
  </div>
</div>
<div class="CssErrorBodyWrapper">
  <div class="no-side-pad">
    <div>
      @for (error of this.errorList; track $index) {
        <div>
          <div class="CssErrorLabel">
            <span [class]="error.environment === CLIENT ? 'fad fa-browser' : 'fad fa-server'"></span
            >{{ error.label ? error.label : 'Neznana napaka' }}
          </div>
          <div [innerHTML]="error.message | ixEscapeHtml"></div>
          <div [innerHTML]="error.instructions | ixEscapeHtml"></div>
          <div>
            <button
              pButton
              type="button"
              icon="far fa-fw fa-info"
              class="CssErrorReportingDialog p-button-secondary"
              title="Podrobnosti"
              label="Podrobnosti"
              [ngClass]="{ CssActiveButton: error.openDetails }"
              (click)="error.openDetails = !error.openDetails"
            ></button>
          </div>
          @if (!!error.openDetails) {
            <div class="CssErrorDetails">
              <hr />
              <div class="CssFormItem">
                <div class="CssFormLabel">Uporabnik:</div>
                <div>
                  {{ comVizitkaDTO?.userName }}
                </div>
              </div>

              <div class="CssFormItem">
                <div class="CssFormLabel">Čas:</div>
                <div>
                  {{ error.timestamp | ixDateHourMinuteSecondFormatSi }}
                </div>
              </div>

              <div class="CssFormItem">
                <div class="CssFormLabel">Verzija:</div>
                <div>
                  Baza: {{ comVizitkaDTO?.databaseAppVersion }}, Servis:
                  {{ comVizitkaDTO?.appVersion }}, Klient:
                  {{ comVizitkaDTO?.appVersion }}
                </div>
              </div>

              @if (error.stackTrace) {
                <div class="callstack">
                  <div class="CssFormLabel">Sled napake:</div>
                  {{ error.stackTrace }}
                </div>
              }
            </div>
          }
        </div>
        <hr />
      }

      <div class="CssReportError">
        <a [href]="this.reportLink" target="_blank">
          <div>Prijavi napako</div>
        </a>
      </div>
    </div>
  </div>
</div>
